import React from "react";
import { Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTools } from "@fortawesome/free-solid-svg-icons";

const UnderConstructionCard = () => {
  return (
    <Card className='mb-3 index-card' cypressid={`under_construction_cypressid`}>
      <Card.Body className='text-center'>
          <FontAwesomeIcon className='font-icon mb-2' icon={faTools} style={{ color: "#147995", fontSize: "500%" }} />
          <br />
          <span style={{ color: "#5fa7be" }}>Coming soon to a Waterlink near you!</span>
      </Card.Body>
    </Card>
  );
};

export default UnderConstructionCard;
